import {
    ActivityLogsQueryParams,
    ActivityLogsResponse,
    ActivityLogsResponseSchema,
    EntityUrlType
} from '@/features/entity-activity-logs/types'
import axios, {parseResponseData} from '@/axiosInstance'
import {captureException} from '@sentry/react'

export interface HttpGetEntityActivityLogsOptions {
    urlParams: {
        entityType: EntityUrlType
        entityId: string
    }
    params?: ActivityLogsQueryParams
}

export const HttpGetEntityActivityLogsResponse = ActivityLogsResponseSchema
export type HttpGetEntityActivityLogsResponse = ActivityLogsResponse

export const httpGetEntityActivityLogs = async ({
    urlParams,
    params
}: HttpGetEntityActivityLogsOptions): Promise<HttpGetEntityActivityLogsResponse> => {
    const response = await axios.get(`/v1/${urlParams.entityType}/${urlParams.entityId}/logs`, {params})

    return parseResponseData({
        responseData: response.data,
        onZodError: captureException,
        responseShape: HttpGetEntityActivityLogsResponse
    })
}
